import { createContext } from "react";

const destinationContext = createContext();

export default destinationContext;
